module.exports = __webpack_public_path__ + "static/media/checkbox-deselected.b68d422e.png";